<!--
 * @Description: mark
 * @Author: wangwangwang
 * @Date: 2020-10-14 09:34:35
 * @LastEditors: 刘小二
 * @LastEditTime: 2025-03-14 11:33:10
-->
<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>
export default {
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true,
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  }
}
</script>

<style lang="scss">
// 全局引入图库
@import "./assets/icon/iconfont.css";
#nprogress .bar {
  background: #ff9865 !important; //自定义颜色
}
.title-input {
  .el-input {
    height: 24px;
    width: 120px;
    .el-input__inner {
      height: 24px;
      color: $bg_color;
      font-size: 20px;
      font-weight: bold;
      border: 0;
      background: #f7f9fc;
      padding: 0;
    }
    input::-webkit-input-placeholder {
      color: $bg_color;
    }
  }
}
.el-pagination__editor.el-input .el-input__inner {
  line-height: 24px !important;
}
.el-message {
  top: 40px !important;
}
</style>
